(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("x-ray"));
	else if(typeof define === 'function' && define.amd)
		define(["x-ray"], factory);
	else if(typeof exports === 'object')
		exports["fetchFavicon"] = factory(require("x-ray"));
	else
		root["fetchFavicon"] = factory(root["x-ray"]);
})(this, function(__WEBPACK_EXTERNAL_MODULE_1__) {
return 


// WEBPACK FOOTER //
// webpack/universalModuleDefinition